import { useState, useEffect, useRef, useCallback } from 'react';

// Singleton global pour tracker les requêtes uniques
const fetchRegistry = {};

export const useSingletonFetch = (fetchKey, fetchFunction, dependencies = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const mountedRef = useRef(false);

  const memoizedFetch = useCallback((key, fetchFn) => {
    // Si une requête existe déjà pour cette clé, ne pas la relancer
    if (fetchRegistry[key]) {
      return fetchRegistry[key];
    }

    const fetchPromise = (async () => {
      try {
        const result = await fetchFn();
        
        if (mountedRef.current) {
          setData(result);
          setLoading(false);
        }

        return result;
      } catch (err) {
        if (mountedRef.current) {
          setError(err);
          setLoading(false);
        }
        throw err;
      } finally {
        // Nettoyer le registre après la requête
        delete fetchRegistry[key];
      }
    })();

    // Stocker la promesse dans le registre
    fetchRegistry[key] = fetchPromise;

    return fetchPromise;
  }, []);

  useEffect(() => {
    mountedRef.current = true;

    memoizedFetch(fetchKey, fetchFunction);

    return () => {
      mountedRef.current = false;
    };
  }, [fetchKey, fetchFunction, memoizedFetch]);

  return { data, loading, error };
};
